export const services = [
  {
    id: 'wedding-website',
    title: 'Wedding Website',
    description: 'Create a beautiful, customizable wedding website to share your love story.',
    icon: 'fas fa-globe',
    image: '/img/service/web.jpg',
  },
  {
    id: 'invitation-system',
    title: 'Invitation System',
    description: 'Easily manage guest responses and track attendance.',
    icon: 'fas fa-check-circle',
    image: '/img/service/invitation.jpg',
  },
  {
    id: 'guest-wishes',
    title: 'Guest Wishes',
    description: 'Let your guests share their heartfelt wishes and blessings.',
    icon: 'fas fa-heart',
    image: '/img/service/wish.jpg',
  },
  {
    id: 'wedding-chatbot',
    title: 'Wedding Chatbot',
    description: 'Get instant answers to your wedding questions.',
    icon: 'fab fa-line',
    image: '/img/service/chatbot.jpg',
  },
  {
    id: 'payment-verification',
    title: 'Payment Verification',
    description: 'Receive and manage payment slips through our Line chatbot.',
    icon: 'fas fa-money-bill-wave',
    image: '/img/service/payment.jpg',
  },
  {
    id: 'back-office',
    title: 'Back Office',
    description: 'Manage your RSVPs and payment verifications in one convenient dashboard.',
    icon: 'fas fa-desktop',
    image: '/img/service/web-admin.jpg',
  },
];
